import React, { Component } from 'react'
import SelectBox from "../SelectBox";

// 기본 데이터 요소
const defaultData = {
  isShow: false,
  title: "내용을 체크 해 주세요.",
  data: [],
  filterData: []
}

class Popup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShow: defaultData.isShow,
      title: defaultData.title,
      data: defaultData.data,
      filterData: defaultData.filterData
    }
  }

  componentDidMount() {
    // 팝업 활성화 여부
    this.props.isShow && this.setState({ isShow : true })
    // 팝업 타이틀 텍스트 
    this.props.title && this.setState({ title : this.props.title })
    // 팝업 내 셀렉트 박스 노출 데이터 & 검색 데이터
    this.props.data && this.setState({ data : this.props.data, filterData : this.props.data })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    if(nextProps.data) {
      this.setState({ filterData : nextProps.data })
    }
  }

  // 팝업 닫기 이벤트
  closePopup = () => {
    this.setState({
      isShow: false
    })
    
    this.props.closeEvent();
  }

  // 팝업내 검색 & 셀렉트 박스 데이터 변환
  autocomplete = (event) => {
    let val = event.target.value
    
    this.setState({
      filterData : this.state.data.filter(
        obj => obj.name.toUpperCase().indexOf(val.toUpperCase()) !== -1
      )
    })
  }

  onAdd = (event) => {
    this.props.onAdd(event);
  }

  onRemove = (event) => {
    this.props.onRemove(event);
  }

  render() {
    const { closePopup, autocomplete } = this;

    return (
      <div 
        className={`modal ${ this.state.isShow ? "show" : "" }`} 
        id="search1" 
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="con-title">{ this.state.title }</h3>
            </div>
            <div className="modal-body">
              <div className="input-btn mb-3">
                <input 
                  type="text" 
                  className="form-control"
                  onChange={autocomplete}
                />
                <button type="button" className="btn-control"><span className="icon icon-size-24 icon-search-gray" /></button>
              </div>
              {
                this.state.filterData.length > 0 ? 
                (
                    <SelectBox
                        name={this.props.name}
                        title="선택해주세요"
                        isMulti
                        currentData={this.props.currentData}
                        OptionData={this.state.filterData}
                        onAdd={this.onAdd}
                        onRemove={this.onRemove}
                    />
                ) : (
                  <label>검색 결과가 없습니다.</label>
                )
              }
              
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-darkblue" onClick={closePopup}><strong>닫기</strong></button>
            </div>
            <button type="button" className="btn-close" onClick={closePopup}></button>
          </div>
        </div>
      </div>
    )
  }
}

export default Popup;
